module.exports = __webpack_public_path__ + "static/media/599.702(9).b0beef02.pdf";